import { PaymentRawdataCSVDownloader } from "../../../organisms/smart-apply/payment/payment-rawdata/csv-downloader";
import { usePayment3DSecureAuthRawdataHooks } from "./3dsecure-auth-hooks";

export const Payment3DSecureAuthRawdata = () => {
  const { isLoading, terms, targetYYYYMM, setTargetYYYYMM, onDownload } =
    usePayment3DSecureAuthRawdataHooks();

  return (
    <PaymentRawdataCSVDownloader
      hiddenSelectYYYYMM={false}
      buttonText={"CSVダウンロード"}
      isLoading={isLoading}
      terms={terms}
      targetYYYYMM={targetYYYYMM}
      setTargetYYYYMM={setTargetYYYYMM}
      onDownload={onDownload}
    />
  );
};
